import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { downloadUsefulDoc } from '../../services/axios-client/axeCommons';
import { UsefulDocumentsStyles } from './UsefulDocuments.styles';
import { getUsefulDocuments } from '../../features/usefulDocuments/usefulDocumentsActions';
import PageLoading from '../../common/components/elements/PageLoading';

export function UsefulDocuments() {
  const { loading, documents } = useSelector((state) => state.usefulDocuments.documents);

  // const filesList = [
  //   {
  //     id: 1,
  //     name: 'Scarico Greenia.pdf',
  //   },
  //   {
  //     id: 2,
  //     name: 'Privacy.pdf',
  //   },
  //   {
  //     id: 3,
  //     name: 'precontrattuale completa Greenia.pdf',
  //   },
  //   {
  //     id: 4,
  //     name: 'Dichiarazione CF errato.pdf',
  //   },
  //   {
  //     id: 5,
  //     name: 'stato-di-famiglia.pdf',
  //   },
  //   {
  //     id: 6,
  //     name: 'modello-autocertificazione-residenza.pdf',
  //   },
  // ];

  // const downloadFile = (documentId) => {
  //   downloadUsefulDoc(documentId);
  // };

  const downloadDocument = async (documentId) => {
    if (documentId === undefined) {
      return;
    }
    const response = await downloadUsefulDoc(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  useEffect(() => {
    getUsefulDocuments();
  }, []);

  if (loading) {
    return <PageLoading />;
  }

  return (
    <UsefulDocumentsStyles>

      <div className="row mt-2">
        <h5 className="mb-3">Documenti Utili</h5>
      </div>
      <ul className="list-group ">
        {/* {filesList.map((f, index) => (
          <li className="list-group-item d-flex justify-content-between align-items-center" key={index}>
            <div className="me-auto">
              <div className="fw-bold">{f.name}</div>
            </div>
            <div className="btn btn-success" onClick={() => downloadFile(f.id)}>Scarica</div>

          </li>
        ))} */}
        {documents?.map((document, index) => (
          <li className="list-group-item d-flex justify-content-between align-items-center" key={index}>
            <div className="me-auto">
              <div className="fw-bold">{document.filename}</div>
              {/* {document.original_filename} */}
            </div>
            <div className="btn btn-success" onClick={() => downloadDocument(document.id)}>Scarica</div>

          </li>
        ))}
      </ul>
    </UsefulDocumentsStyles>
  );
}
